export default "__VITE_ASSET__B4Ct5VoW__"